import { EntidadeBase } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
class ContratoModel extends EntidadeBase {
    constructor() { super('contrato'); }
    async provisionar(id) { return await ApiService.post('contrato/provisionar', { id }); }
    async consultarCnpj(cnpj) { return await ApiService.post('contrato/consultarcnpj', { cnpj }); }
    async trocarModalidade(id, modalidade) { return await ApiService.post('contrato/trocarmodalidade', { id, modalidade }); }
}

const instance = new ContratoModel();
export default instance;
